import React, { useState, useLayoutEffect, useRef } from 'react';
import "./PeriodicElementFamily.css";

const PeriodicElementFamily = ({ size, color, number, element, name, weight }) => {
    const wrapperRef = useRef(null);
    const [ratios, setRatios] = useState({ font: 1, position: 1 });

    useLayoutEffect(() => {
        const updateDimensions = () => {
            if (wrapperRef.current) {
                const width = wrapperRef.current.clientWidth;
                const fontRatio = 198 / width;
                const positionRatio = 1 - (Math.abs(fontRatio - 1) / 10);

                setRatios({ font: fontRatio, position: positionRatio });
            }
        };

        // Calcul initial
        updateDimensions();

        // Gestion du resize
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);

    // Styles calculés pour alléger le rendu
    const containerStyle = { width: `${size}px`, height: `${size}px` };
    const wrapperStyle = {
        ...containerStyle,
        borderColor: color
    };

    return (
        <div className="PeriodicElementFamily" style={containerStyle}>
            <div className="PeriodicElementFamily-Wrapper" style={wrapperStyle} ref={wrapperRef}>
                <p className="PeriodicElementFamily-Number"
                   style={{
                       fontSize: `${25 / ratios.font}px`,
                       top: `${1 / ratios.position}%`,
                       left: `${2.5 / ratios.position}%`,
                       color: color
                   }}>{number}</p>

                <p className="PeriodicElementFamily-Element"
                   style={{
                       fontSize: `${100 / ratios.font}px`,
                       top: `${14 / ratios.position}%`,
                       color: color
                   }}>{element}</p>

                <p className="PeriodicElementFamily-Name"
                   style={{
                       fontSize: `${22 / ratios.font}px`,
                       bottom: `${11 / ratios.position}%`,
                       color: color
                   }}>{name}</p>

                <p className="PeriodicElementFamily-Weight"
                   style={{
                       fontSize: `${15 / ratios.font}px`,
                       bottom: `${2.5 / ratios.position}%`,
                       color: color
                   }}>{weight}</p>
            </div>
        </div>
    );
};

export default PeriodicElementFamily;